// REACT
import React, {
	useContext,
	RefObject,
	useRef,
	CSSProperties,
	Dispatch,
	SetStateAction,
	useState,
	useEffect,
} from 'react'
import { Link } from 'react-router-dom'

// ESTILOS
import Styles from './Home.module.css'

// ASSETS
import G0 from 'Assets/Gallery/00.jpg'
import G1 from 'Assets/Gallery/01.jpg'
import G2 from 'Assets/Gallery/02.jpg'
import G3 from 'Assets/Gallery/03.jpg'

// COMPONENTES
import Carousel from 'Components/Carousel/Carousel'
import DatePicker from 'Components/DatePicker/DatePicker'
import Location from 'Components/Location/Location'
import Scroll from 'Components/Scroll/Scroll'

// CONTEXTO
import MainContext from 'Context/MainContext'

// HERRAMIENTAS
import { scrollToHideSection } from 'Utils/Tools'

// ESTADOS
interface HomeState {
	update: boolean
}

// ASSETS
const imgs: string[] = [
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F00.jpg?alt=media&token=3d674f83-28c2-4a14-989f-d207862e65bf',
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F01.jpg?alt=media&token=dfebcfc6-368a-41a9-9856-d8b9b673c7f6',
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F02.jpg?alt=media&token=bd38f688-c9d8-4e3a-8fdc-e9b46aa7e927',
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F03.jpg?alt=media&token=b7124e6f-6d8f-4bf3-b99d-b083685966ff',
]

// CACHE
const imgsFallback: string[] = [G0, G1, G2, G3]

// ESTADO POR DEFECTO
const DefSate: HomeState = {
	update: false,
}

const Home: React.FC = () => {
	// CONTEXTO
	const { home } = useContext(MainContext).lang

	// ESTADO
	const [state, setState]: [HomeState, Dispatch<SetStateAction<HomeState>>] = useState(DefSate)

	// REFERENCIAS
	const homeRef: RefObject<HTMLDivElement> = useRef(null)

	// SCROLL
	const goDown = () => scrollToHideSection(homeRef.current, true)

	// CLASSES
	const carClass: CSSProperties = { width: '100%', height: '100%' }

	// ACTUALIZAR IMAGENES
	useEffect(() => {
		const time = setTimeout(() => setState({ update: true }), 4000)
		return () => clearTimeout(time)
	}, [])

	return (
		<section className={`${Styles.container} ${Styles.page1}`} ref={homeRef}>
			{!state.update ? (
				<Carousel imgs={imgsFallback} class1={carClass} class2={carClass} />
			) : (
				<Carousel imgs={imgs} update={state.update} class1={carClass} class2={carClass} />
			)}

			<div className={Styles.contCar}>
				<div className={Styles.contInfo}>
					<h1>
						{home.title}
						<br />
						{home.title_2}
					</h1>
					<p>{home.text}</p>
					<Location />
					<div className={Styles.contInfoButtons}>
						<DatePicker className={Styles.pickers} />
						<Link to='/reservaciones' title='Reservar' className={Styles.sendBtn}>
							<i className='lni lni-arrow-right' />
							{home.btn}
						</Link>

						<Link to='/galeria' title='Galeria' className={Styles.sendBtn}>
							<i className='lni lni-image' />
							{home.gBtn}
						</Link>
					</div>
					<Scroll dark={false} className={Styles.scroll} action={goDown} />
				</div>
			</div>
		</section>
	)
}

export default Home
